import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { WsService } from '../ws/ws.service';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})

export class TimerComponent implements OnInit, OnDestroy {

  private startStamp: any;
  private counterTimeout: any;
  public timeString: any;

  public ST: any;
  public state: any;
  private stateSubscription: Subscription;

  constructor(private ws: WsService) {
      this.ST = this.ws.ST;
      this.state = this.ws.getState();
      this.stateSubscription = this.ws.onState.subscribe(this.onChangeState.bind(this));
      this.resetCounter();
  }

  private onChangeState(state: any): void {
      this.state = state;
      this.resetCounter();
  }

  private resetCounter(): void {
      this.startStamp = Math.floor(new Date().valueOf() / 1000);
      if (this.counterTimeout) {
          clearTimeout(this.counterTimeout);
      }
      this.incrementCounter();
  }

  private incrementCounter(): void {
      this.formatTimeString();
      this.counterTimeout = setTimeout(this.incrementCounter.bind(this), 1000);
  }

  private formatTimeString(): void {
      const nowStamp = Math.floor(new Date().valueOf() / 1000);
      const counter = nowStamp - this.startStamp;
      const hours = Math.floor(counter / 3600);
      const minutes = Math.floor((counter - (hours * 3600)) / 60);
      const seconds = counter - hours * 3600 - minutes * 60;
      this.timeString = hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
  }

  ngOnInit() {
  }

  ngOnDestroy() {
      this.stateSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/timer/timer.component.ts